import { ChevronsUpDown } from 'lucide-react'
import { cn } from '@/utils/cn'

const thBase =
  'px-4 py-3 text-left text-[var(--font-color-label)] font-medium uppercase tracking-wider whitespace-nowrap'

function SortableTh({
  label,
  field,
  sortField,
  onSort,
  className,
}: {
  label: string
  field: string
  sortField: string
  onSort: (field: string) => void
  className?: string
}) {
  const isActive = sortField === field

  return (
    <th scope="col" className={cn(thBase, className)}>
      <button
        type="button"
        onClick={() => onSort(field)}
        className="inline-flex items-center gap-1.5 hover:text-text-primary transition-colors"
      >
        {label}
        <ChevronsUpDown
          size={14}
          className={cn('shrink-0', isActive ? 'text-accent opacity-100' : 'text-text-muted opacity-40')}
          aria-hidden
        />
      </button>
    </th>
  )
}

function PlainTh({ label, className }: { label: string; className?: string }) {
  return (
    <th scope="col" className={cn(thBase, className)}>
      {label}
    </th>
  )
}

type Props = {
  sortField: string
  onSort: (field: string) => void
}

export function CloserLeadsTableHeader({ sortField, onSort }: Props) {
  return (
    <thead>
      <tr className='border-b border-[var(--glass-border)]'>
        <SortableTh label="Empresa / Contato" field="empresa" sortField={sortField} onSort={onSort} />
        <PlainTh label="Telefone" className="hidden md:table-cell" />
        <SortableTh label="Status" field="status" sortField={sortField} onSort={onSort} />
        <PlainTh label="Temperatura" className="hidden lg:table-cell" />
        <PlainTh label="Próxima ação" className="hidden xl:table-cell" />
        <PlainTh label="Ação" className="text-left" />
      </tr>
    </thead>
  )
}
